export default __webpack_public_path__ + "static/kig_eng-133526924895b39db9583b3d1e202814.png";